import _ from 'lodash';
import Vue from 'vue';

function formatAmount(amount) {
  if (amount) {
    return amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }
  return amount;
}

function formatAmountWithFraction(value, fractionDigits = 1) {
  const amount = Math.abs(Number(value));
  const result = amount.toLocaleString(undefined, { maximumFractionDigits: fractionDigits, minimumFractionDigits: fractionDigits });
  return result.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

// Money that may carry agorot: 27.5 stays 27.5 and 33 stays 33, so a displayed price is never a
// different amount from the one charged.
function formatAmountKeepingAgorot(value) {
  const amount = Math.abs(Number(value));
  return amount.toLocaleString(undefined, { maximumFractionDigits: 2 });
}

function signedFormatAmountWithFraction(value, fractionDigits = 1) {
  return `${formatAmountWithFraction(value, fractionDigits)}${value < 0 ? '-' : ''}`;
}

const DEFAULT_CURRENCY_SYMBOL = '₪';
// Igor normalizes the common currencies to a symbol before storing them and lets
// anything it doesn't recognize through as the raw ISO code, so a transaction can
// arrive with either form.
const CURRENCY_SYMBOLS = {
  ILS: DEFAULT_CURRENCY_SYMBOL,
  NIS: DEFAULT_CURRENCY_SYMBOL,
  USD: '$',
  EUR: '€',
  GBP: '£',
};

// Falls back to shekels: most transactions carry no currency at all, and the ones
// that don't are overwhelmingly local.
function currencySymbol(currency) {
  return CURRENCY_SYMBOLS[currency] || currency || DEFAULT_CURRENCY_SYMBOL;
}

function isLocalCurrency(currency) {
  return currencySymbol(currency) === DEFAULT_CURRENCY_SYMBOL;
}

Vue.filter('signedFormatAmountWithFraction', signedFormatAmountWithFraction);
Vue.filter('formatAmountWithFraction', formatAmountWithFraction);
Vue.filter('shekel', value => `${value} ₪`);

function extractRoundedDecimalPart(number, precision) {
  return (10 * (_.round(number, precision))) % 10;
}

function extractRoundedIntegerPart(number, precision) {
  return Math.trunc(_.round(number, precision));
}

function calculatePriceAfterDiscount(price, discountPercentage) {
  return price * (1 - discountPercentage / 100);
}

export default {
  formatAmount,
  formatAmountWithFraction,
  formatAmountKeepingAgorot,
  currencySymbol,
  isLocalCurrency,
  signedFormatAmountWithFraction,
  extractRoundedDecimalPart,
  extractRoundedIntegerPart,
  calculatePriceAfterDiscount,
};
